import { useBackendApi } from './backendApi';
import { useEventsPublisher } from 'event-bus';

export interface CreateTokensRequest {
  code: string;
}

export interface CalendarConfiguration {
  email: string;
  isValid: boolean
}

export interface GoogleLinkResponse {
  link: string;
}

export const EVENT_CONFIGURATION_DELETED = 'EVENT_CONFIGURATION_DELETED';


export enum EventConfigurationErrorCode {
  REQUIRED_SCOPE_NOT_GRANTED = 'REQUIRED_SCOPE_NOT_GRANTED',
  INVALID_CODE = 'INVALID_CODE',
}

export function useEventsConfigurationService() {
  const nekstApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const getGoogleLink = async (): Promise<GoogleLinkResponse> => {
    return await nekstApi.get('/events/configuration/google/link');
  };

  const createTokens = async (request: CreateTokensRequest): Promise<CalendarConfiguration> => {
    return await nekstApi.post('/events/configuration/google/tokens', request);
  };

  const deleteTokens = async (): Promise<void> => {
    await nekstApi.delete('/events/configuration/google/tokens');
    eventsPublisher.publish(EVENT_CONFIGURATION_DELETED, {})
  };

  const getConfiguration = async (): Promise<CalendarConfiguration> => {
    return await nekstApi.get('/events/configuration');
  };

  return {
    getGoogleLink,
    createTokens,
    deleteTokens,
    getConfiguration,
  };
}
